import React, { useContext, useEffect } from 'react';
import { Card, CardHeader, CardBody, Container, Row, Col, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import { isSuperAdmin } from '../../utils/helpers';
import { Store } from '../../Store';
import client from '../../utils/client';

const superAdmin = isSuperAdmin();

const Contact = () => {
  const { t } = useTranslation();

  const { state, dispatch } = useContext(Store);
  const adminContact = state.adminContact?.data;

  useEffect(() => {
    (async () => {
      if (!adminContact) {
        const { data } = await client('admin-gc/club-info');
        dispatch({
          type: 'ADMIN_CONTACT_FETCHED',
          payload: {
            name: data.admContactName,
            email: data.admContactEmail,
            phone: data.admContactPhone
          }
        });
      }
    })();
  }, []);

  const crash = () => {
    throw new Error('💥 CABOOM 💥');
  };

  return (
    <>
      <SimpleHeader name={t('contact.title')} />

      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">{t('contact.sub-title')}</h3>
                  {/* <Trans key="contact.title" /> */}
                </CardHeader>
                <CardBody>
                  <p>{t('contact.text')}</p>
                  {adminContact && (
                    <p>
                      <strong>{adminContact.name}</strong>
                      <br />
                      <a href={`mailto:${adminContact.email}`}>{adminContact.email}</a>
                      <br />
                      <a href={`tel:${adminContact.phone}`}>{adminContact.phone}</a>
                    </p>
                  )}
                  {superAdmin && <Button onClick={() => crash()}> Crash for Sentry</Button>}
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Contact;
